import React, { Component } from "react";
import produce from "immer";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import _ from "lodash";
import { quiz4OnGoingUpdate } from "../../actions/quiz4OnGoingActions";
const qs = require("query-string");

class Feedback extends Component {
  constructor(props) {
    super(props);

    this.state = {
      uid: null,
      db: null,
      feedbacks: []
    };
  }

  componentDidMount() {
    const { location } = this.props;
    const params = qs.parse(location.search);
    this.setState(
      produce(draft => {
        draft.uid = params.uid;
      })
    );
  }

  componentDidUpdate(prevProps, prevState) {
    const { quiz4OnGoing } = this.props;
    const { uid, db } = this.state;
    const newDb = quiz4OnGoing.filter(db => db.uid === uid)[0] || [];

    const { feedbacks: newDbFeedbacks } = newDb.onGoing || [];
    if (!_.isEqual(db, newDb)) {
      this.setState(
        produce(draft => {
          draft.db = newDb;
          draft.feedbacks = newDbFeedbacks || [];
        })
      );
    }
  }

  handleChange = (idx, e) => {
    const { value } = e.target;
    this.setState(
      produce(draft => {
        draft.feedbacks[idx] = value;
      })
    );
  };

  handleSubmit = (idx, e) => {
    e.preventDefault();
    console.log("submit", idx, this.state.feedbacks[idx]);
    const {
      uid,
      feedbacks,
      db: { currentClass }
    } = this.state;
    this.props.quiz4OnGoingUpdate(uid, currentClass, feedbacks);
  };

  checkFeedbackChange = (front, db) => {
    // prevent error on data changing..
    if (!(front || db)) return true;
    // in case of already filled front loaded
    else if (front && front === db) return true;
    // in case of edit already exist text
    else if (front && front !== db) return false;
    else return false;
  };

  renderForm = ({ currentClass, name, uid, onGoing }) => {
    const { answers, questionsRandomOrder: questions } = onGoing;
    const { feedbacks } = this.state;
    const { feedbacks: dbFeedbacks } = onGoing || [];
    console.log(feedbacks, dbFeedbacks);
    return (
      <>
        {questions.map((q, idx) => (
          <div className="row my-3" key={idx}>
            <div className="col-2">
              <span className="badge badge-primary">문제</span>
            </div>
            <div className="col-10">{q.question}</div>

            <div className="col-2">
              <span className="badge badge-primary">입장</span>
            </div>
            <div className="col-10">{answers[idx].position}</div>

            <div className="col-2">
              <span className="badge badge-primary">이유/근거</span>
            </div>
            <div className="col-10">{answers[idx].reason}</div>

            <div className="col-2">
              <span className="badge badge-primary">강조</span>
            </div>
            <div className="col-10">{answers[idx].emphasis}</div>

            <div className="col-12">
              <form onSubmit={e => this.handleSubmit(idx, e)}>
                <div className="row">
                  <div className="col-2">
                    <span className="badge badge-primary">피드백</span>
                  </div>
                  <div className="col-8">
                    <textarea
                      name="feedbacks"
                      type="text"
                      rows="2"
                      style={{
                        width: "100%",
                        border: feedbacks[idx]
                          ? "1px solid gray"
                          : "1px dotted red"
                      }}
                      onChange={e => this.handleChange(idx, e)}
                      value={feedbacks[idx]}
                    />
                  </div>
                  <div className="col-2">
                    <button
                      type="submit"
                      className="d-block w-100 btn btn-danger btn-block"
                      style={{ height: "100%" }}
                      disabled={
                        this.checkFeedbackChange(
                          feedbacks[idx],
                          dbFeedbacks ? dbFeedbacks[idx] : undefined
                        )
                        // dbFeedbacks ? feedbacks[idx] === dbFeedbacks[idx] : true
                      }
                    >
                      확인
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        ))}
      </>
    );
  };

  render() {
    const { db } = this.state;
    const { name } = db || {};
    return (
      <div className="row">
        <div className="col-12">
          <h1>피드백: {name}</h1>
        </div>
        <div className="col-12">{!_.isEmpty(db) && this.renderForm(db)}</div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  quiz4OnGoing: state.quiz4OnGoing
});

export default withRouter(
  connect(
    mapStateToProps,
    { quiz4OnGoingUpdate }
  )(Feedback)
);
